export function replaceVariables(
  template: string,
  values: { [key: string]: string },
): string {
  return template.replace(/\$\{(.*?)\}/g, (_, key) => {
    return values[key.trim()] ?? `\${${key}}`;
  });
}
